export const sidebarItems = [
  {
    path: "/dashboard",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke="#fff"
        width="20.8"
        height="20.8"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-layout-dashboard"
      >
        <rect width="7" height="9" x="3" y="3" rx="1" fill="none" />
        <rect width="7" height="5" x="14" y="3" rx="1" fill="none" />
        <rect width="7" height="9" x="14" y="12" rx="1" fill="none" />
        <rect width="7" height="5" x="3" y="16" rx="1" fill="none" />
      </svg>
    ),
    text: "Dashboard",
  },
  {
    path: "/charts",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke="#fff"
        strokeWidth="2.25"
        strokeLinecap="round"
        width="20.8"
        height="20.8"
        strokeLinejoin="round"
        className="lucide lucide-chart-line"
      >
        <path d="M3 3v16a2 2 0 0 0 2 2h16" fill="none" />
        <path d="m19 9-5 5-4-4-3 3" fill="none" />
      </svg>
    ),
    text: "Data",
  },
  {
    path: "/simulator",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        stroke="#fff"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-ship"
      >
        <path d="M12 10.189V14" fill="none" />
        <path d="M12 2v3" fill="none" />
        <path
          d="M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"
          stroke="#fff"
          fill="none"
        />
        <path
          d="M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76"
          stroke="#fff"
          fill="none"
        />
        <path
          d="M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"
          stroke="#fff"
          fill="none"
        />
      </svg>
    ),
    text: "Ship Model",
  },
  {
    path: "/configuration",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke="#fff"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        width="20.8"
        height="20.8"
        className="lucide lucide-sliders-horizontal"
      >
        <line x1="21" x2="14" y1="4" y2="4" />
        <line x1="10" x2="3" y1="4" y2="4" />
        <line x1="21" x2="12" y1="12" y2="12" />
        <line x1="8" x2="3" y1="12" y2="12" />
        <line x1="21" x2="16" y1="20" y2="20" />
        <line x1="12" x2="3" y1="20" y2="20" />
        <line x1="14" x2="14" y1="2" y2="6" />
        <line x1="8" x2="8" y1="10" y2="14" />
        <line x1="16" x2="16" y1="18" y2="22" />
      </svg>
    ),
    text: "Configuration",
  },

  {
    path: "/",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        stroke="#fff"
        width="20.8"
        height="20.8"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-log-out"
      >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" fill="none" />
        <polyline points="16 17 21 12 16 7" fill="none" />
        <line x1="21" x2="9" y1="12" y2="12" />
      </svg>
    ),
    text: "Log Out",
    onClick: (setIsLoggedIn) => {
      setIsLoggedIn(false);
      localStorage.setItem("userID", "");
    },
  },
];
